import ArrowLeft from '@assets/svg/ArrowLeft';
import { useAppRouter } from '@my-medication/shared-components/providers/AppRouterProvider';
import { cn } from '@my-medication/shared-components/shadcn/utils';
import { Button } from '@my-medication/shared-components/ui/Button';
import { AdminPortalKeys, Namespace } from '@i18n/translations';
import { type FunctionComponent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from '../PageTitle';
import { type PageLayoutProps } from './PageLayout.types';

const PageLayout: FunctionComponent<PageLayoutProps> = ({ headline, children, className }) => {
  const { t, i18n } = useTranslation(Namespace.AdminPortal);
  const { navigateTo } = useAppRouter();

  const backToOverview = useCallback(() => {
    navigateTo({ name: 'Admin Welcome', params: { locale: i18n.language } });
  }, [navigateTo, i18n.language]);

  return (
    <div className={cn('box-border w-full py-6', className)}>
      <div className="mx-auto flex max-w-350 px-4">
        <Button
          name="back-to-overview"
          variant="ghost"
          startIcon={<ArrowLeft className="size-6! **:stroke-secondary-900 **:stroke-4!" />}
          onClick={backToOverview}
          className="h-auto w-fit items-center bg-transparent p-0 tracking-wider text-secondary-900 uppercase hover:bg-transparent hover:underline"
        >
          {t(AdminPortalKeys.BackToOverview)}
        </Button>
      </div>

      {headline && (
        <div className="mx-auto max-w-350 px-4">
          <PageTitle>{headline}</PageTitle>
        </div>
      )}

      {children && <div className="mx-auto flex min-h-128 max-w-350 flex-wrap">{children}</div>}
    </div>
  );
};

PageLayout.displayName = 'PageLayout';

export { PageLayout };
